jQuery(document).ready(function($) {
    $('#post-carousel').each(function() {
        let carouselContainer = $(this);
        let itemsToShow = 3; // <=== controls the number of items to display in each page
        let items = 13; // this controls the total number of items
        let page = jQuery('<div class="carousel-item active">');
        let nextPageAt = itemsToShow - 1;
        let paginationNumber = $(carouselContainer).find('#pagination-numbers');
        let carouselItem = $(carouselContainer).find('.carousel-item');
        let pagination = $(carouselContainer).find('#pagination');
        let leftArrow = $(carouselContainer).find('#left');
        let rightArrow = $(carouselContainer).find('#right');

        $('.carousel').carousel({
            interval: false,
        });

        jQuery(paginationNumber).text(`1/${jQuery(carouselItem).length}`)
        if (items <= itemsToShow) {
            jQuery(pagination).addClass('d-none')
        }

        jQuery(leftArrow).click(function () {
            jQuery(carouselContainer).carousel('prev')
            window.scrollTo({
                top: 100,
                left: 100,
                behavior: 'smooth'
            });
        })

        jQuery(rightArrow).click(function () {
            jQuery(carouselContainer).carousel('next')
            window.scrollTo({
                top: 100,
                left: 100,
                behavior: 'smooth'
            });
        })

        jQuery(carouselContainer).on('slid.bs.carousel', function () {
            const totalItems = carouselContainer.find('.carousel-item').length
            const currentIndex = carouselContainer.find('div.active').index() + 1
            jQuery(paginationNumber).text('' + currentIndex + '/' + totalItems + '')
        })

    })
})